import { ObjectDataRecord } from '@types'

const simplifyFieldPath = (fieldPath: string): string => {
  return fieldPath.includes('.') ? fieldPath.split('.')[0] : fieldPath
}

export const sortObjectData = (
  data: ObjectDataRecord[],
  sortRules: string[]
): ObjectDataRecord[] => {
  // Преобразуем строки вида "field,direction" в объекты {field, direction}
  const parsedRules = sortRules.map(rule => {
    const [fieldPath, direction] = rule.split(',') as [string, 'asc' | 'desc']
    // TODO CORE API Обратить внимание после перехода на api core
    // Сортировка поля может уходить на бэк в виде airline_ref.country_ref.name
    // Но в данных name нам приходит в поле airline_ref благодаря сервису данных бэка WisKey Front
    // Поэтому преобразуем airline_ref.country_ref.name в airline_ref для корректной сортировки на фронте
    const simpleField = simplifyFieldPath(fieldPath)

    return { field: simpleField, direction }
  })

  const sortedData = [...data]

  sortedData.sort((a, b) => {
    for (const { field, direction } of parsedRules) {
      const valueA = a[field]
      const valueB = b[field]

      // Обработка null и undefined
      if (valueA == null && valueB == null) continue // Оба null/undefined — пропускаем

      // Для сортировки по убыванию null должны идти в конце
      if (direction === 'desc') {
        if (valueA == null) return 1 // null в конец
        if (valueB == null) return -1 // null в конец
      }
      // Для сортировки по возрастанию null должны идти в конце
      else {
        if (valueA == null) return 1 // null в конец
        if (valueB == null) return -1 // null в конец
      }

      // Number
      if (typeof valueA === 'number' && typeof valueB === 'number') {
        const comparison = valueA - valueB
        if (comparison !== 0) {
          return direction === 'asc' ? comparison : -comparison
        }
        continue
      }

      // String
      if (typeof valueA === 'string' && typeof valueB === 'string') {
        const comparison = valueA.localeCompare(valueB) // Простое сравнение Unicode
        if (comparison !== 0) {
          return direction === 'asc' ? comparison : -comparison
        }
        continue
      }

      // Boolean
      if (typeof valueA === 'boolean' && typeof valueB === 'boolean') {
        const comparison = Number(valueA) - Number(valueB) // false=0, true=1
        if (comparison !== 0) {
          return direction === 'asc' ? comparison : -comparison
        }
        continue
      }

      // Всё остальное
      const strA = String(valueA)
      const strB = String(valueB)
      const comparison = strA.localeCompare(strB)
      if (comparison !== 0) {
        return direction === 'asc' ? comparison : -comparison
      }
    }

    return 0
  })

  return sortedData
}
